import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initField } from './field';
import {
    initActiveSection,
    initCardSpotlight,
    initReveals,
    initScroll,
    initScrollProgress,
} from './scroll';
import { getMotionPref, initMotionToast, initRestoreMotionBanner } from './motionToast';

/*
 * Motion for the services page and every service page: smooth scroll, the
 * particle field (with the page's looks), entrances and the reduced-motion
 * toast. Without motion the page stays static and fully readable.
 */
export function initServicesPage(looks) {
    try {
        // Honour saved user override first, then fall back to the OS setting
        const prefersReduced = getMotionPref();

        initActiveSection();

        if (!prefersReduced) {
            // Smooth scrolling only with a mouse on wide screens; touch keeps native scroll
            if (window.innerWidth >= 900 && window.matchMedia('(pointer: fine)').matches) initScroll();

            const field = initField(document.getElementById('servicesField'), looks);
            if (field) {
                document.body.classList.add('has-field');
                ScrollTrigger.addEventListener('refresh', field.measure);
            }

            initScrollProgress();
            initReveals();
            initCardSpotlight();

            // If the OS has reduced motion but the user hasn't been asked yet,
            // show a toast so they can consciously opt in to the full experience.
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                initMotionToast(() => {
                    // "Yes, reduce effects" chosen — reload to apply the reduced-motion state from the top with a clean slate
                    window.location.reload();
                });
            }
        } else {
            // Show the end-of-page restore button if the user previously chose 'reduced'
            initRestoreMotionBanner();
        }
    } catch (error) {
        console.error('Error initializing services page:', error);
    } finally {
        document.documentElement.classList.remove('js-motion');
    }
}
